import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../styles/constants';

export const useStyles = makeStyles(theme => ({
	tableRow: {
		height: 23,
		'&:last-child td': {
			borderBottom: 0,
			fontWeight: props => (props.withTotalRow ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular)
		}
	},
	listItem: {
		padding: 0,
		lineHeight: 1.5,
		display: 'block'
	},
	toolbar: {
		padding: 0,
		paddingLeft: theme.spacing(1)
	},
	actionsContainer: {
		marginTop: theme.spacing(2.5),
		marginBottom: theme.spacing(0.5)
	},
	footer: {
		borderTop: `1px solid ${COLORS.BORDER}`,
		paddingTop: theme.spacing(3)
	},
	totalValueTableCell: {
		padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
		fontWeight: theme.typography.fontWeightBold,
		borderBottom: 0
	}
}));
